"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteWithGetInitialProps = exports.Route = void 0;
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
function Route(props) {
    return (react_1.default.createElement(react_router_1.__RouterContext.Consumer, null, function (context) {
        var location = context.location;
        var match = props.computedMatch;
        var newProps = __assign(__assign({}, context), { location: location, match: match });
        var render = props.render;
        return (react_1.default.createElement(react_router_1.__RouterContext.Provider, { value: newProps }, newProps.match ?
            render(__assign(__assign({}, props.layoutProps), newProps)) :
            null));
    }));
}
exports.Route = Route;
var prePathname;
// 是否是路由切换
var routeChanged = false;
function RouteWithGetInitialProps(props) {
    var _this = this;
    var _a = props.route.component, originComponent = _a.originComponent, originGetInitialProps = _a.getInitialProps;
    var _b = __read(react_1.useState(), 2), initialprops = _b[0], setInitialprops = _b[1];
    var _c = __read(react_1.useState({
        hasGetInitialProps: typeof (originComponent === null || originComponent === void 0 ? void 0 : originComponent.load) !== 'function',
        getInitialProps: originGetInitialProps
    }), 2), getInitialPropsObj = _c[0], setGetInitialPropsObj = _c[1];
    var hasInitialprops = false;
    return (react_1.default.createElement(react_router_1.__RouterContext.Consumer, null, function (context) {
        var location = context.location;
        var match = props.computedMatch;
        var newProps = __assign(__assign({}, context), { location: location, match: match });
        var render = props.render;
        // @ts-ignore query
        var _a = location || {}, pathname = _a.pathname, query = _a.query;
        var getInitialProps = getInitialPropsObj.getInitialProps, hasGetInitialProps = getInitialPropsObj.hasGetInitialProps;
        routeChanged = routeChanged || (prePathname && prePathname !== pathname);
        prePathname = pathname;
        /**
         * 兼容 loadable 路由按需加载
         */
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var _getInitialProps;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof (originComponent === null || originComponent === void 0 ? void 0 : originComponent.load) === 'function' && routeChanged && !getInitialPropsObj.hasGetInitialProps)) return [3 /*break*/, 2];
                        return [4 /*yield*/, originComponent.load()];
                    case 1:
                        _getInitialProps = (_a = (_b.sent()).default) === null || _a === void 0 ? void 0 : _a.getInitialProps;
                        setGetInitialPropsObj({
                            hasGetInitialProps: true,
                            getInitialProps: _getInitialProps
                        });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })();
        /**
         * 当前 component 有 getInitialProps 时
         * 路由切换获取 getInitialProps
         */
        if (routeChanged && getInitialProps && !initialprops) {
            hasInitialprops = true;
            getInitialProps({ pathname: pathname, query: query }).then(function (data) {
                setInitialprops(data);
            });
        }
        return (react_1.default.createElement(react_router_1.__RouterContext.Provider, { value: newProps }, newProps.match &&
            (hasGetInitialProps || !routeChanged) && (!hasInitialprops || (hasInitialprops && initialprops)) ?
            render(__assign(__assign(__assign({}, props.layoutProps), initialprops), newProps)) :
            null));
    }));
}
exports.RouteWithGetInitialProps = RouteWithGetInitialProps;
//# sourceMappingURL=Route.js.map